import { IoChevronForwardOutline } from "react-icons/io5";
import { Link, useParams , useOutletContext } from "react-router";
import styled from "styled-components";

import BimClassEditor from "./BimClassEditor";
import BimClassRevisions from "./BimClassRevisions";
import BimClassTitle from "./BimClassTitle";
import GeometryTypes from "./GeometryTypes";
import { TAXONOMY_BASE } from "../../../../../constants";
import { CssSectionCard } from "../../../components/styles";

import type { BimClassOutletContext } from "../WithBimClassInventory";

const StyledBimClassDetail = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 280px 320px 1fr;
    gap: 20px;
    height: 100%;
    min-height: 0;
    overflow: hidden;

    .section-card {
        ${ CssSectionCard }
    }

    .nav-breadcrumbs {
        align-items: center;
        display: flex;
        gap: 6px;
        font-size: 0.8rem;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebecf0;

        a {
            color: #6b778c;
            text-decoration: none;
            font-weight: 500;

            &:hover {
                color: #0052cc;
            }
        }

        svg {
            color: #a5adba;
            font-size: 0.75rem;
        }

        .current {
            color: #172b4d;
            font-weight: 600;
        }
    }
`;

export default function BimClassDetail() {
    const { bimClassID, bimClassRevisionID } = useParams();
    const guard = useOutletContext<BimClassOutletContext>();

    return (
        <StyledBimClassDetail>
            {/* Section 1: Geometry Types & Nav */}
            <div className="section-card">
                <div className="nav-breadcrumbs">
                    <Link to={ TAXONOMY_BASE }>Home</Link>
                    <IoChevronForwardOutline />
                    <Link to={ `${ TAXONOMY_BASE }/BimClasses` }>BimClasses</Link>
                    <IoChevronForwardOutline />
                    <span className="current">Detail</span>
                </div>
                <GeometryTypes
                    guard={ guard }
                    id={ bimClassID }
                />
            </div>

            {/* Section 2: Revisions & Title */}
            <div className="section-card">
                <BimClassTitle
                    id={ bimClassID }
                    revisionID={ bimClassRevisionID }
                />
                <BimClassRevisions
                    guard={ guard }
                    id={ bimClassID }
                    revisionID={ bimClassRevisionID }
                />
            </div>

            {/* Section 3: BimClass Editor */}
            <div className="section-card">
                <BimClassEditor
                    guard={ guard }
                    id={ bimClassID }
                    key={ bimClassRevisionID }
                    revisionID={ bimClassRevisionID }
                />
            </div>
        </StyledBimClassDetail>
    );
}
